/**
 * Useful tools for working with OpenSeadragon
 * @class
 */

var viewer;

window.ws = new WebSocket('ws://storiiies.cogapp.com/broadcast-signal');
document.addEventListener('DOMContentLoaded', function() {
  initialiseViewer();

  // Websocket stuff
  ws.onmessage = function(msg){
    var data = JSON.parse(msg.data);

    // What is the type of message?
    // this could be a tilesource or position data
    if (data.type === 'init') {
      if (typeof(data.payload.tileSources) !== 'undefined') {
        viewer.open(data.payload.tileSources);
        if (typeof(data.payload.position) !== 'undefined') {
          window.initPosition = data.payload.position;
        }
      }
    } else if (data.type === 'position') {
      viewer.viewport.zoomTo(data.payload.zoom, data.payload.center);
      viewer.viewport.panTo(data.payload.center);
    } else if (data.type === 'tileSources') {
      viewer.open(data.payload);
    }
  };
});

function initialiseViewer() {
  var ping;
  var gestureSettings = {
    scrollToZoom: false,
    clickToZoom: false,
    dblClickToZoom: false,
    pinchToZoom: false,
    pinchRotate: false,
    flickEnabled: false
  };

  // Really stripped back functionality on the viewer
  viewer = OpenSeadragon({
    id: 'osd-viewer',
    prefixUrl: '/vendor/openseadragon/images/',
    minZoomLevel: 1,
    defaultZoomLevel: 1,
    panHorizontal: false,
    panVertical: false,
    visibilityRatio: 0.5,
    gestureSettingsMouse: gestureSettings,
    gestureSettingsTouch: gestureSettings,
    gestureSettingsPen: gestureSettings,
    gestureSettingsUnknown: gestureSettings,
    zoomPerClick: 1,
    zoomPerScroll: 1,
    showNavigationControl: false,
    showZoomControl: false,
    showSequenceControl: false,
    showRotationControl: false,
    showFullPageControl: false,
    immediateRender: true // This is for potential mobile perf gains
  });
  ping = setInterval(function() {
    ws.send(JSON.stringify({type: 'ping', payload: 'pong'}));
  }, 20000);
  viewer.addHandler('open', function() {
    viewer.viewport.zoomTo(initPosition.zoom,initPosition.center);
    viewer.viewport.panTo(initPosition.center);
  });
}
